// 55338
// 58875
$(document).ready(function () {
    $("#pdpEmbeddingVideosModalPD").on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var recipient = button.data('whatever');
        var iframeVideoUrl = recipient + "?autoplay=1";
        var modal = $(this);
        modal.find("#videoPDIframe").append('<iframe id="pdpPDvideo" class="pdp-video embed-responsive-item" src=' + iframeVideoUrl + ' title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        event.stopImmediatePropagation();
    });

    $("#pdpEmbeddingVideosModalPD").on('hide.bs.modal', function () {
        $("#pdpPDvideo").remove();
    });
});
